module.exports = __webpack_public_path__ + "img/integration1.e5b4f498.webp";